import { ArrowUpRight } from "lucide-react";
import { GIFT_PATHWAYS } from "@/data/mockData";
import { SITE_CONFIG } from "@/data/siteConfig";

export default function Gifts() {
  return (
    <div data-testid="gifts-page" className="bg-cream">
      <section className="bg-bone border-b border-rule py-16 md:py-24">
        <div className="container-wide grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-end">
          <div className="lg:col-span-7">
            <p className="text-sm font-semibold text-forest mb-4">Shop · Gifts</p>
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[1]">
              Gifts for people
              <br />
              {" "}<span className="italic text-clay">who love to make.</span>
            </h1>
          </div>
          <div className="lg:col-span-5">
            <p className="text-ink leading-relaxed max-w-lg">
              Browse the current Cactus Rose gift selection and pricing in the
              Shopify store.
            </p>
            <a
              href={SITE_CONFIG.links.shopify}
              target="_blank"
              rel="noreferrer"
              className="btn-primary mt-7"
            >
              Shop Gifts Online
              <ArrowUpRight className="w-4 h-4" strokeWidth={1.7} />
            </a>
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="container-wide">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {GIFT_PATHWAYS.map((gift) => (
              <article key={gift.id}>
                <div className="aspect-[4/3] overflow-hidden bg-oat">
                  <img src={gift.image} alt="" className="w-full h-full object-cover" />
                </div>
                <h2 className="font-sans text-xl font-semibold mt-5">{gift.title}</h2>
                <p className="mt-2 text-sm leading-relaxed text-ink">{gift.copy}</p>
              </article>
            ))}
          </div>
          <p className="mt-12 max-w-2xl text-sm leading-relaxed text-ink">
            {SITE_CONFIG.inventory.notice}
          </p>
        </div>
      </section>
    </div>
  );
}
